import * as React from 'react';

import cx from 'classnames';

import type { SemanticContentColors } from 'glossDS/types/colors';

import styles from './Text.module.css';

type Props = {
  children: React.ReactNode;
  as?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'dd' | 'dt';
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';
  type?: 'regular' | 'bold' | 'display';
  className?: string;
  id?: string;
  semanticColor?: SemanticContentColors | 'inherit';
};

export const Text = ({
  children,
  as = 'span',
  size = 'base',
  semanticColor = 'primary',
  type = 'regular',
  className,
  id,
}: Props) => {
  const sizeClass = styles[`size-${size}`];
  const typeClass = styles[type];
  const semanticColorValue =
    semanticColor === 'inherit' ? 'inherit' : `var(--content-${semanticColor})`;

  return React.createElement(
    as,
    {
      id,
      style: {
        '--text-component-color': semanticColorValue,
      } as React.CSSProperties,
      className: cx([styles.root, sizeClass, typeClass, className]),
    },
    children,
  );
};
